import { z } from 'zod'

export const SIGNER_STATUSES = [
  'waiting',
  'pending',
  'viewed',
  'signed',
  'declined',
  'cancelled',
] as const

export const signerStatusSchema = z.enum(SIGNER_STATUSES)

export type SignerStatus = z.infer<typeof signerStatusSchema>

export const LIVE_SIGNER_STATUSES = [
  'waiting',
  'pending',
  'viewed',
] as const satisfies readonly SignerStatus[]

export const PRISMA_SIGNER_STATUSES = [
  'WAITING',
  'PENDING',
  'VIEWED',
  'SIGNED',
  'DECLINED',
  'CANCELLED',
] as const

export type PrismaSignerStatus = (typeof PRISMA_SIGNER_STATUSES)[number]

export const SIGNER_STATUS_FROM_PRISMA = {
  WAITING: 'waiting',
  PENDING: 'pending',
  VIEWED: 'viewed',
  SIGNED: 'signed',
  DECLINED: 'declined',
  CANCELLED: 'cancelled',
} as const satisfies Record<PrismaSignerStatus, SignerStatus>

export const SIGNER_STATUS_TO_PRISMA = {
  waiting: 'WAITING',
  pending: 'PENDING',
  viewed: 'VIEWED',
  signed: 'SIGNED',
  declined: 'DECLINED',
  cancelled: 'CANCELLED',
} as const satisfies Record<SignerStatus, PrismaSignerStatus>

/** The Prisma status for a wire status. The map's `satisfies` makes a missing status fail the build. */
export function prismaSignerStatus(status: SignerStatus): PrismaSignerStatus {
  return SIGNER_STATUS_TO_PRISMA[status]
}

/** {@link LIVE_SIGNER_STATUSES} in the casing Prisma stores. */
export const LIVE_PRISMA_SIGNER_STATUSES: readonly PrismaSignerStatus[] = LIVE_SIGNER_STATUSES.map(
  (status) => prismaSignerStatus(status),
)
